import { render, staticRenderFns } from "./TextInputWithHtml.vue?vue&type=template&id=012b6fca&"
import script from "./TextInputWithHtml.vue?vue&type=script&lang=js&"
export * from "./TextInputWithHtml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('012b6fca')) {
      api.createRecord('012b6fca', component.options)
    } else {
      api.reload('012b6fca', component.options)
    }
    module.hot.accept("./TextInputWithHtml.vue?vue&type=template&id=012b6fca&", function () {
      api.rerender('012b6fca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/devices/shared/components/formcomponents/TextInputWithHtml.vue"
export default component.exports